import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footershape from '../../../assets/images/shapes/site-footer-shape-1.png';
// import footerLogo from '../../../assets/images/resources/site-footer-logo-1.png';
import navLogo from "../../../assets/images/resources/logo-1.png";
const Footer = () => {
    
  const [posts, setPosts] = useState([]);

 useEffect(() => {
    fetch('https://rsvpevents.local/wp-json/wp/v2/categories?slug=blog')
      .then(response => response.json())
      .then(categories => {
        const blogCategory = categories[0];
        if (blogCategory) {
          fetch(`https://rsvpevents.local/wp-json/wp/v2/posts?categories=${blogCategory.id}&per_page=5`)
            .then(response => response.json())
            .then(posts => setPosts(posts))
            .catch(error => console.error('Error fetching posts:', error));
        } else {
          console.warn('No category found with slug "blog"');
        }
      })
      .catch(error => console.error('Error fetching category:', error));
  }, []);

  return (
    <>
    {/* Site Footer Start */}
    <footer className="site-footer">
        <div className="site-footer__shape-1 float-bob-y">
            <img src={Footershape} alt="" />
        </div>
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/">
                            <img src={navLogo} alt="" />
                        </Link>
                    </div>
                    {/* <div className="site-footer__social">
                        <Link to="#"><i className="icon-facebook"></i></Link>
                        <Link to="#"><i className="icon-fi"></i></Link>
                        <Link to="#"><i className="icon-instagram"></i></Link>
                        <Link to="#"><i className="icon-pinterest"></i></Link>
                    </div> */}
                </div>
            </div>
        </div>
        <div className="site-footer__middle">
            <div className="container">
                <div className="site-footer__middle-inner">
                    <div className="row">
                      
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Quick links</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/event">Events</Link></li>
                                    <li><Link to="/promo-codes">Promo Codes</Link></li>
                                    <li><Link to="/about">About</Link></li>
                                    <li><Link to="/event-news">Event News</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div className="footer-widget__column footer-widget__our-company">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Event News</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    {posts.map(post => (
                                    <li key={post.id}><Link to={`/event-news-details/${post.slug}`} dangerouslySetInnerHTML={{ __html: post.title.rendered }}/></li>
                                     ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                            <div className="footer-widget__column footer-widget__contact">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Contact</h3>
                                </div>
                                <div className="footer-widget__contact-inner">
                                    <ul className="footer-widget__contact-list list-unstyled">
                                        <li>
                                            <div className="icon">
                                                <span className="icon-envelop"></span>
                                            </div>
                                            <div className="text">
                                                <p><a href="mailto:info@rsvppass.com">info@rsvppass.com</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>123 Event Street, San Diego, CA 92101, USA</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-call"></span>
                                            </div>
                                            <div className="text">
                                                <p>+1 (619) 555-1234</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-clock"></span>
                                            </div>
                                            <div className="text">
                                                <p>Mon-Fri, 9:00 AM - 5:00 PM (PST)</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© RSVP 2024 | All Rights Reserved</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        <li><Link to="/terms-and-conditions">Terms & Condition</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    {/* Site Footer End */}
    </>
  );
};

export default Footer;
